module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



/*****************
 ** WEBPACK FOOTER
 ** ./~/prop-types/lib/has.js
 ** module id = 1331
 ** module chunks = 0
 **/